<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Delete License Server</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <p>
    Do you want to delete the license server <label for="" class="fs-6 text-danger">{{ licenseServerName }}</label> ?
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary"  (click)="onClose()">No</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()" cdkFocusInitial>
    Yes
  </button>
</div>